<!--
     <ManyToManyMatrix
       :cols="{text: 'a text', tooltip: 'a tooltip', value: 'myid', rows: Set(['rowid'])}"
       :rows="{text: 'a text', tooltip: 'a tooltip', value: 'rowid'}"
       @cellclick="manage_cell(col_value, row_value)"
       column_name="Products"
       row_name="Shops"
       ref="m2mm"
       :row_name_width="480px"
     />

     Public methods:
       set_loading(col_value, row_value, state)
         // state is true/false
         // Cells will display a loading wheel when state is true
         // Loading cells won't be clickable
-->

<template>
  <div>
  <div class="m2mm-layout">
    <table class="m2mm" border="0" cellspacing="0" colpadding="0">
      <tr class="m2mm-header">
        <th class="m2mm">
          <th class="m2mm m2mm-rotate" v-for="col in cols" :key="col.value">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="m2mm-centroname" @click="manage_colclick(col)">
                  <span>{{ col.text }}</span>
                </div>
              </template>
              <span v-if="!!col.tooltip" style="white-space: pre-line;">{{ col.tooltip }}</span>
            </v-tooltip>
          </th>
        </th>
      </tr>
        <tr class="m2mm" v-for="row in current_rows" :key="row.value">
          <td class="m2mm m2mm-rowname" :style="rowname_style">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs"  class="m2mm-rowcenter m2mm-rowname-div" @click="manage_rowclick(row)">
                  {{ row.text }}
                </div>
              </template>
              <span v-if="!!row.tooltip">{{ row.tooltip }}</span>
            </v-tooltip>
          </td>
          <td
            class="m2mm"
            v-for="col in cols"
            :key="(col.key || col.value) + ',' + (row.key || row.value)"
            @click="manage_cellclick(col.value, row.value)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs"  class="m2mm-fullsize">
                  <div class="m2mm-check" v-if="loading_col_row.indexOf(col.value+','+row.value) >= 0">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="24"
                    ></v-progress-circular>
                  </div>
                  <div class="m2mm-check yes" v-else-if="col.rows.has(row.value)">
                    <v-icon>mdi-check-bold</v-icon>
                  </div>
                  <div class="m2mm-check" v-else>
                    <v-icon>mdi-cancel</v-icon>
                  </div>
                </div>
              </template>
              <span>
                <div style="width: 100%">
                  <span style="font-weight: bold">{{ column_name }}</span>
                  : <span>{{ col.text }}</span>
                </div>
                <div style="width: 100%">
                  <span style="font-weight: bold">{{ row_name }}</span>
                  : <span>{{ row.text }}</span>
                </div>
              </span>
            </v-tooltip>
          </td>
        </tr>
    </table>
    
  </div>
  <div class="d-flex" style="justify-content: flex-end; align-items: center;">
    <v-select 
      class="v-data-footer__select"
      v-model="rows_per_page"
      :items="rows_pages"
      height="32"
      dense
      hide-details
      @change="page = 1"
    />
    <span class="pl-2 pagination-item">
        {{ (page - 1) * rows_per_page + 1 }} -
        {{ last_item_page }} de
        {{ rows.length }}
      </span>
    <v-pagination 
      v-model="page"
      :length="pages"
      :total-visible="5"
    />
  </div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 $table_border_width: 1px;
 $cell_width: 32px;
 $cell_height: 32px;
 $cell_border-color: #444444;

 .m2mm-layout {
   display: flex;
   flex-direction: row;
   padding: 18px 0ps 18px 0px;
   width: 100%;
   min-height: 90%;
   overflow: scroll;
   padding-right: 120px;
 }

 td.m2mm {
   width: $cell_width;
   min-width: $cell_width;
   border-style: solid;
   border-width: 0px $table_border_width $table_border_width 0px;
   border-color: $cell_border-color;
   height: $cell_height;
   min-height: $cell_height;
 }
 td.m2mm:nth-child(even) {
   background-color: #e4e4e4;
   color: #fff;
 }

 td.m2mm-rowname {
   /* min-width: 480px; *//* see prop row_name_width */
   border-width: 0px 1px 1px 0px;
 }

 .m2mm-rowname-div {
   justify-content: flex-end;
   text-align: right;
   padding-right: 12px;
   font-weight: bold;
 }

 th.m2mm-rotate {
   position: relative;
   border-style: solid;
   border-width: 0px 0px $table_border_width 0px;
   border-color: $cell_border-color;
 }

 .m2mm-centroname {
   white-space: nowrap;
   border-style: solid;
   border-width: 0px;
   border-color: $cell_border-color;
   text-align: left;
   writing-mode: vertical-lr;

   /* place div at bottom left of the th parent */
   position: absolute;
   bottom: 0;
   left: 0;
   text-align: left;
   transform: 
     translate(calc(100% - $table_border_width / 2), $table_border_width)
     rotate(-65deg);
   transform-origin: 0% calc(100% - $table_border_width);
   width: 100%;
 }

 .m2mm-centroname > span {
   position: absolute;
   bottom: 0;
   left: 0;
   border-bottom: $table_border_width solid $cell_border-color;
 }

 th.m2mm {
   height: 140px;
   width: $cell_width;
 }

 .m2mm-rowcenter {
   display: flex;
   flex-direction: row;
   align-items: center;
   height: 100%; 
 }

 .m2mm-check {
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: transparent;
 }

 .m2mm-check.yes {
   background-color: #22ff2288;
   color: white;
 }

 .m2mm-fullsize {
   width: 100%;
   height: 100%;
 }
 .m2mm-fullsize:hover {
   background-color: #888;
 }
</style>


<script>
  export default {
    name: 'ManyToManyMatrix',

    components: {},

    props: {
      cols: {required: true},
      rows: {required: true},
      column_name: {default: 'Column'},
      row_name: {default: 'Row'},
      row_name_width: {default: '480px'},
    },

    data: () => ({
      loading_col_row: [],
      page: 1,
      rows_per_page: 10,
      
    }),

    computed: {
      rowname_style() {
        return `width: ${this.row_name_width}; min-width: ${this.row_name_width};`;
      },
      rows_pages() {
        return [
          {text: "5", value: 5},
          {text: "10", value: 10},
          {text: "20", value: 20},
          {text: "Todos", value: this.rows.length},
        ]
      },
      pages() {
        return Math.ceil(this.rows.length / this.rows_per_page) 
      },
      current_rows() {

        const first = ((this.page - 1) || 0) * (this.rows_per_page || 10);
        const last = (this.page || 1) * (this.rows_per_page || 10);
        
        return this.rows.slice(first,last);
      },
      last_item_page() {
        const last_page = this.page == this.pages;
        return last_page ? this.rows.length : this.page * this.rows_per_page;
      }
    },

    methods: {
      set_loading(col_value, row_value, state) {
        // state is true/false
        // Cells will display a loading wheel when state is true
        // Loading cells won't be clickable
        const lkey = `${col_value},${row_value}`
        const pos = this.loading_col_row.indexOf(lkey);
        if (state) {
          if (pos < 0) {
            this.loading_col_row.push(lkey);
          }
        } else {
          if (pos >= 0) {
            this.loading_col_row.splice(pos, 1);
          }
        }
      },

      manage_cellclick(col_value, row_value) {
        if (this.loading_col_row.indexOf(`${col_value},${row_value}`) >= 0) {
          return;
        }
        this.$emit('cellclick', col_value, row_value);
      },

      manage_rowclick(row) {
        this.$emit('row_click',row);
      },

      manage_colclick(col) {
        this.$emit('col_click',col);
      },
    },
  }
</script>


